import React from "react";
import { useTheme } from "@material-ui/core/styles";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  ReferenceLine,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import dayjs from "dayjs";
dayjs.locale("ja");

export default function Chart({ data, meta, target, dataKey, onClick }) {
  const theme = useTheme();
  let reached = [];
  let released = [];

  if(meta.limit) {
    reached = meta.limit.reached_at;
    released = meta.limit.released_at;
  }

  const timestanp = (date) => {
    switch (target) {
      case "monthly":
        return dayjs(date).format("YYYY-MM-DD");
      case "daily":
        return dayjs(date).format("YYYY-MM-DD HH:00");
      case "hourly":
        // 5分単位に丸める(0詰め2桁)
        const roundMinute = ("0" + parseInt((dayjs(date).minute())/5)*5).slice(-2);
        return (dayjs(date).format("YYYY-MM-DD HH:")) + roundMinute;
    }
  }

  return (
    <React.Fragment>
      <ResponsiveContainer>
        <LineChart
          width={500}
          height={300}
          data={data}
          margin={{
            top: 25,
            right: 30,
            left: 20,
            bottom: 10,
          }}
          onClick={(data) =>
            {
              if (data != null) {
                return onClick(data.activeLabel)
              }
            }
          }
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey={dataKey} />
          <YAxis />
          {reached.map((row, index) => (
            <ReferenceLine
              key={index}
              x={timestanp(row)}
              stroke="red"
              label={{ position: 'top', value: "取得停止", fill: 'red' }}
            />
          ))}
          {released.map((row, index) => (
            <ReferenceLine
              key={index}
              x={timestanp(row)}
              stroke="green"
              label={{ value: '取得再開', fill: 'green' }}
            />
          ))}
          <Tooltip />
          <Line
            type="monotone"
            dataKey="count"
            stroke={theme.palette.primary.main}
          />
        </LineChart>
      </ResponsiveContainer>
    </React.Fragment>
  );
}
